var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCamera = function SvgCamera(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.375 7.466h14.886v13.977H1.375V7.466Zm1.25 1.25v11.477h12.386V8.716H2.625Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.625 8.96v10.987l-7.614-3.263v-4.46l7.614-3.263Zm-6.364 4.088v2.812l5.114 2.192v-7.195l-5.114 2.191ZM7.74 2.92h8.522V5.99h-1.25V4.17H7.739V2.92Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.8 12.96a1.071 1.071 0 1 0 0-2.142 1.071 1.071 0 0 0 0 2.143Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.8 11.71a.179.179 0 1 0 0 .358.179.179 0 0 0 0-.357Zm1.071.179a1.071 1.071 0 1 1-2.143 0 1.071 1.071 0 0 1 2.143 0Z",
    fill: "currentColor"
  })));
};
export default SvgCamera;